
import Vue from 'vue';

import SummDirective from './SummDirective'
import SelectAllDirective from './SelectAllDirective'
import MaskDirective from './MaskDirective'

Vue.directive('summ', SummDirective)
Vue.directive('select-all', SelectAllDirective)
Vue.directive('mask', MaskDirective)